import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import coverImage from '../../assets/img/login.svg';
import { Auth } from 'aws-amplify';

const Login = (props) => {

  const [formFields, setFormFields] = useState({ section_code: '', password: '' });
  const [isFormValid, setFormValid] = useState(false);

  useEffect(() => {
    /** Debouncing */
    const timer = setTimeout(() => {
      let checkForm = true;
      for (const [key, value] of Object.entries(formFields)) {
        if (validateField(key) !== '') {
          checkForm = false;
        }
      }
      setFormValid(checkForm);
    }, 200);
    return () => {
      clearTimeout(timer);
    }
  }, [formFields]);

  const validateField = (name) => {
    let error = '';
    /** Generic test */
    error = formFields[name].length == 0 ? 'Please enter valid value' : '';
    return error;
  }

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    const formFieldsObject = {
      ...formFields,
      [name]: value
    }
    setFormFields(formFieldsObject);
  }

  const submitHandler = async (event) => {
    event.preventDefault();
    if (!isFormValid) return;
    try {
      const response = await Auth.signIn(formFields.section_code, formFields.password);
      localStorage.setItem('refreshToken', response.signInUserSession.refreshToken.token)
      props.signInSuccess();
    }
    catch (error) {
      alert(error.message)
    }

  }

  return (
    <React.Fragment>
      <div className="unauth-main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 col-lg-5 pe-0 ps-0">
              <div className="login-left-image">
                <img className="img-fluid" src={coverImage} />
              </div>
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 pe-0 ps-0">
              <div className="login-form-detail">
                <div className="welcome-title text-center mb-5">
                  <h4>Sign In</h4>
                </div>
                <form action="" method="">
                  <div className="mb-3 forms-input">
                    <i className="fa fa-mobile" aria-hidden="true"></i>
                    <label className="mb-2">Section Code</label>
                    <input type="text" onChange={handleChange} value={formFields['section_code']} placeholder="Section Code" name="section_code" className="form-control" />
                  </div>
                  <div className="mb-3 forms-input">
                    <i className="fa fa-lock" aria-hidden="true"></i>
                    <label className="mb-2">Password</label>
                    <input onChange={handleChange} type="password" value={formFields['password']} placeholder="Password" name="password" className="form-control" />
                  </div>
                  <div className="mb-4 form-check remember-forgotten ps-0">
                    <div className="form-check me-auto">
                      <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                      <label className="form-check-label" for="flexCheckDefault">Remember me</label>
                    </div>
                    <div className="forgot">
                      <Link to="/forgot-password">Forgot Password</Link>
                    </div>
                  </div>
                  <button type="submit" onClick={submitHandler} className={`btn btn-primary mb-3 ${isFormValid ? 'custom-active' : ''}`}>Login</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Login;